import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'

const OpportunityDropDown = ({ showContact, onToggleFilter }) => {
    const { t } = useTranslation()

    const title = showContact ? 'opportunity.title.contact' : 'opportunity.title.activity'
    const buttonText = showContact ? 'app.common.opportunity' : 'app.common.activities'

    const [dropdownOpen, setDropdownOpen] = useState(false)
    
    const toggle = () => setDropdownOpen((prevState) => !prevState)

    return (
        <div className="d-flex align-items-center flex-grow-1 mt-2 mb-2">
            <p className="m-0">{t(title)}</p>
            <Dropdown
                className="ms-2"
                isOpen={dropdownOpen}
                toggle={toggle}
                direction="down"
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <DropdownToggle tag="button" className="btn btn-light border border-2 d-flex justify-content-between">
                    {t(buttonText)} <i className="mdi mdi-chevron-down ms-2"></i>
                </DropdownToggle>
                <DropdownMenu className="w-100">
                    <DropdownItem onClick={() => onToggleFilter(true)}>{t('app.common.opportunity')}</DropdownItem>
                    <DropdownItem onClick={() => onToggleFilter(false)}>{t('app.common.activities')}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}

export default OpportunityDropDown
